import {
  ANTIGRAVITY_INTEGRATION_NAME,
  CLAUDE_CODE_INTEGRATION_NAME,
  CODEX_INTEGRATION_NAME,
  CURSOR_INTEGRATION_NAME,
  GEMINI_CLI_INTEGRATION_NAME,
  GITHUB_COPILOT_INTEGRATION_NAME,
  type CodingAgentName
} from "@/api/useIntegrations.selector"

export type CodingAgentStep = {
  // Translation key under integrations.<keyPrefix>.howToUse
  key: string
  // Shown in a copyable code block when set
  command?: string
}

export type CodingAgent = {
  keyPrefix: string
  steps: CodingAgentStep[]
}

const AGENT_SKILLS_REPO = "kodem-security/agent-skills"
const AGENT_SKILLS_URL = `https://github.com/${AGENT_SKILLS_REPO}`

// Every agent's guide ends with the shared verify step; these are the steps before it.
// Keyed by every CodingAgentName, so a catalog agent without a guide fails to compile.
export const CODING_AGENTS: Record<CodingAgentName, CodingAgent> = {
  [CLAUDE_CODE_INTEGRATION_NAME]: {
    keyPrefix: "claudeCode",
    steps: [
      { key: "add", command: `/plugin marketplace add ${AGENT_SKILLS_REPO}` },
      { key: "install", command: "/plugin install kodem-security@kodem" }
    ]
  },
  [CODEX_INTEGRATION_NAME]: {
    keyPrefix: "codex",
    steps: [
      {
        key: "add",
        command: `codex plugin marketplace add ${AGENT_SKILLS_REPO}`
      },
      { key: "install", command: "codex plugin add kodem-security@kodem" }
    ]
  },
  [CURSOR_INTEGRATION_NAME]: {
    keyPrefix: "cursor",
    steps: [
      {
        key: "add",
        command: `cursor-agent plugin marketplace add ${AGENT_SKILLS_URL}`
      },
      { key: "install" }
    ]
  },
  [GEMINI_CLI_INTEGRATION_NAME]: {
    keyPrefix: "geminiCli",
    steps: [
      { key: "download", command: `git clone ${AGENT_SKILLS_URL}` },
      {
        key: "install",
        command: "gemini extensions install ./agent-skills/gemini"
      }
    ]
  },
  [GITHUB_COPILOT_INTEGRATION_NAME]: {
    keyPrefix: "githubCopilot",
    steps: [
      {
        key: "add",
        command: `copilot plugin marketplace add ${AGENT_SKILLS_REPO}`
      },
      { key: "install", command: "copilot plugin install kodem-security@kodem" }
    ]
  },
  [ANTIGRAVITY_INTEGRATION_NAME]: {
    keyPrefix: "antigravity",
    steps: [
      { key: "download", command: `git clone ${AGENT_SKILLS_URL}` },
      {
        key: "install",
        command: "agy plugin install ./agent-skills/antigravity"
      }
    ]
  }
}
